import { useCallback } from 'react';

import type { DeliveryOrderDetailInput, PartialProduct } from '@order/graphql';
import {
  useAddLineItemToCart,
  useNavigateToProductDetails,
} from '@order/hooks';

export const useProductCallbacks = ({
  product,
  restaurantSlug,
  deliveryAddressId,
  deliveryDetails,
}: UseProductCallbacksProps) => {
  const { addLineItemToCart } = useAddLineItemToCart();
  const navigateToProduct = useNavigateToProductDetails({
    restaurantSlug,
    deliveryAddressId,
  });

  const handleCardPress = useCallback(() => {
    navigateToProduct(product);
  }, [product, navigateToProduct]);

  const handleAddToBag = useCallback(async () => {
    await addLineItemToCart({ product, deliveryDetails });
  }, [product, deliveryDetails, addLineItemToCart]);

  return { handleCardPress, handleAddToBag };
};

type UseProductCallbacksProps = {
  readonly product: PartialProduct;
  readonly restaurantSlug?: string;
  readonly deliveryAddressId?: string;
  readonly deliveryDetails?: DeliveryOrderDetailInput;
};
